await import('/code/flow-manager/frontend/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('/code/flow-manager/frontend/src/.umi/umi.ts');
export default 1;